// import React from 'react';
// import AudioPlayer2 from 'react-custom-audio-player';


// const AudioPlayer = ({ audioDataOffline }) => {

//     return (
//         <div>
//             <input type="checkbox" id="my-modal-6" class="modal-toggle" />
//             <div class="modal modal-bottom sm:modal-middle">
//                 <div class="modal-box">
//                     <h3 class="font-bold text-lg">{audioDataOffline?.name} {audioDataOffline?.date}</h3>
//                     <AudioPlayer2 src={audioDataOffline?.link} />
//                     {/* <audio className='mx-auto mt-4' src={audioDataOffline?.link} controls autoPlay></audio> */}
//                     <div class="modal-action">
//                         <label for="my-modal-6" class="btn btn-sm btn-circle btn-accent font-bold text-3xl text-white absolute right-2 top-2"><svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//                             <path strokeLinecap="round" strokeLinejoin="round" d="M20 12H4" />
//                         </svg></label>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default AudioPlayer;


import React, { useEffect, useState } from 'react';
import 'react-h5-audio-player/lib/styles.css';
import AudioPlayer from 'react-h5-audio-player';
import './OfflineAudioPlayer.css';
import { FaPlay, FaWaveSquare } from 'react-icons/fa';
import PlayerSlider from './PlayerSlider';
import bg2 from '../../../assets/images/madrasha.jpeg'

const OfflineAudioPlayer = ({ audioDataOffline, setAudioDataOffline, playlist, currentlyPlayingId, setCurrentlyPlayingId }) => {
    const [currentFile, setCurrentFile] = useState({
        link: audioDataOffline?.link,
        name: audioDataOffline?.name,
        id: audioDataOffline?.id,
    });

    // State to track the playlist index
    const [currentIndex, setCurrentIndex] = useState(playlist?.findIndex(file => file.id === currentlyPlayingId) || 0);

    const handlePlayFromPlaylist = (file, index) => {
        const audioUrl = URL.createObjectURL(file.blob);
        setCurrentFile({ link: audioUrl, name: file.name, id: file.id });
        setAudioDataOffline('play');
        setCurrentIndex(index);
        setCurrentlyPlayingId(file.id)

        // Clean up the URL object when the file changes
        return () => {
            if (audioUrl) {
                URL.revokeObjectURL(audioUrl);
            }
        };
    };

    // Function to handle playing the next audio
    const handleNext = () => {
        const nextIndex = (currentIndex + 1) % playlist.length; // Loop around the playlist
        handlePlayFromPlaylist(playlist[nextIndex], nextIndex);
    };

    // Function to handle playing the previous audio
    const handlePrevious = () => {
        const prevIndex = (currentIndex - 1 + playlist.length) % playlist.length; // Loop around the playlist
        handlePlayFromPlaylist(playlist[prevIndex], prevIndex);
    };

    // Auto-play the next file when current track ends
    const handleAudioEnded = () => {
        handleNext(); // Automatically go to the next track
    };

    useEffect(() => {
        let audioUrl;
        const nowPlay = playlist?.find((cp) => cp.id === currentlyPlayingId);
        if (nowPlay) {
            audioUrl = URL.createObjectURL(nowPlay.blob);
            setCurrentFile({ link: audioUrl, name: nowPlay.name, id: nowPlay.id });
            setCurrentIndex(playlist?.findIndex(file => file.id === currentlyPlayingId)); // Update index
        }

        // Clean up when the component unmounts or the file changes
        return () => {
            if (audioUrl) {
                URL.revokeObjectURL(audioUrl);
            }
        };
    }, [currentlyPlayingId, playlist]);

    console.log(currentFile);
    // console.log(currentlyPlayingId);


    return (
        <div>
            <input type="checkbox" id="my-modal-7" className="modal-toggle" />
            <div className="modal modal-bottom sm:modal-middle">
                <div className="modal-box offline-modal-box p-0">
                    <div className="relative h-screen max-h-screen overflow-hidden flex flex-col">

                        {/* Player Slider (Fixed height, 33vh) */}
                        <div className="relative" style={{ height: '33vh' }}>
                            <div className="w-full flex justify-center items-center mt-10">
                                {/* <PlayerSlider /> */}
                                <img src={bg2} />
                            </div>
                        </div>

                        {/* Marquee effect and Audio Player (Fixed height, 25vh) */}
                        <div className="relative mt-10" style={{ height: '25vh' }}>
                            <div className="offline-marquee-container">
                                <span className="offline-marquee-text mb-2">
                                    {currentFile?.name}
                                </span>
                            </div>

                            {/* Stylish Audio Player */}
                            <AudioPlayer
                                autoPlay
                                src={currentFile?.link}
                                onPlay={() => console.log("Playing")}
                                onEnded={handleAudioEnded} // Handle when audio ends
                                showJumpControls={false} // Disable jump controls
                                showSkipControls // Show next and previous buttons
                                onClickNext={handleNext} // Bind next button
                                onClickPrevious={handlePrevious} // Bind previous button
                            />

                        </div>

                        {/* Playlist (Remaining 42vh, scrollable) */}
                        <h3 className="text-lg font-bold">Playlist</h3>
                        <div className="relative overflow-auto" style={{ height: '42vh' }}>
                            <ul className="playlist text-left">
                                {playlist?.map((file, index) => (
                                    <li
                                        key={file.id}
                                        className={`flex items-center gap-2 playlist-item ${currentFile?.name === file.name ? 'active' : ''} p-2 bg-black bg-opacity-60 mt-px`}
                                        onClick={() => handlePlayFromPlaylist(file, index)}
                                    >
                                        {currentFile.id === file.id ? (
                                            <FaWaveSquare className="text-white-600 animate-pulse" />
                                        ) : (
                                            <FaPlay className="text-white-600" />
                                        )}
                                        {file.type + " "}{(index + 1) + ": "}{file.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Modal Close Button */}
                    <div className="modal-action">
                        <label htmlFor="my-modal-7" className="btn btn-sm btn-circle btn-accent font-bold text-3xl text-white absolute right-2 top-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M20 12H4" />
                            </svg>
                        </label>
                    </div>
                </div>
            </div>
        </div>



    );
};

export default OfflineAudioPlayer;












// import React from 'react';
// import 'react-h5-audio-player/lib/styles.css';
// import AudioPlayer from 'react-h5-audio-player';
// import './OfflineAudioPlayer.css';

// const OfflineAudioPlayer = ({ audioDataOffline, closeModal }) => {

//     return (
//         <div>
//             <input type="checkbox" id="my-modal-7" className="modal-toggle" />
//             <div className="modal modal-bottom sm:modal-middle">
//                 <div className="modal-box">
//                     <div className="marquee-container">
//                         <span className="marquee-text">
//                             {audioDataOffline?.name} - {audioDataOffline?.date}
//                         </span>
//                     </div>

//                     <AudioPlayer
//                         autoPlay
//                         src={audioDataOffline?.link}
//                         onPlay={() => console.log("Playing offline audio")}
//                     />

//                     <div className="modal-action">
//                         <label htmlFor="my-modal-7" className="btn btn-sm btn-circle btn-accent absolute right-2 top-2" onClick={closeModal}>
//                             X
//                         </label>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default OfflineAudioPlayer;
